<div class="column-form" [formGroup]="form">
  <app-simple-checkbox-value-accessor [label]="column.label" formControlName="select">
  </app-simple-checkbox-value-accessor>
  <app-simple-number-value-accessor label="Ilość"
                                    formControlName="number"
                                    appearance="standard"></app-simple-number-value-accessor>
</div>
